import { useEffect, useState } from "react";
import { DashboardLayout } from "./_common/DashboardLayout";
import { broadcastListService } from "../utils/api";
import { notifyError } from "../utils/notify";
import { BiListPlus, BiSolidEditAlt } from "react-icons/bi";

export function Broadcast() {
    // useState
    const [broadcasts, setBroadcasts] = useState([]);

    // useEffect
    useEffect(() => {
        broadcastListService((data) => {
            if (data.success) {
                setBroadcasts(data.result)
            } else {
                notifyError(data.message)
            }
        })
    }, []);


    return <DashboardLayout route="/broadcast">
        <h1 className="text-4xl font-semibold flex justify-between items-center">
            <span>
                Broadcast
            </span>

            <a href="/broadcast/create" className="px-4 py-2 bg-cyan-500 text-white rounded-md hover:bg-cyan-600 text-lg flex items-center">
                <BiListPlus className="text-2xl mr-2" /> Create
            </a>
        </h1>

        <div className="mt-4">
            <div className="bg-white shadow-sm mt-6">
                <table className="w-full border border-gray-300">
                    <thead>
                        <tr className="border-b border-gray-300">
                            <th className="p-2 bg-stone-200">Name</th>
                            <th className="p-2 bg-stone-200">Created At</th>
                            <th className="p-2 bg-stone-200">Edit</th>
                        </tr>
                    </thead>

                    <tbody className="text-center text-sm">
                        {broadcasts.map((broadcast) => {
                            return <tr key={broadcast.id} className="border-b border-gray-300">
                                <td className="p-2">{broadcast.name}</td>
                                <td className="p-2">{new Date(broadcast.created_at).toLocaleString()}</td>
                                <td className="p-2">
                                    <a href={`/broadcast/edit/${broadcast.id}`} className="inline-block text-2xl text-cyan-500">
                                        <BiSolidEditAlt />
                                    </a>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    </DashboardLayout>
}